import { Component, registerComponent } from "aframe";
import { Mesh } from "three";



interface MorphComponent extends Component
{
	data : { [ target : string ] : number }
};



registerComponent("morph", {

	schema : {
		"" : { type : "number", default : 0 }
	},

	multiple : true,

	init(this : MorphComponent)
	{
		this.el.addEventListener("object3dset", (event) =>
		{
			if(event.detail.type == this.id)
				this.update({});
		});
	},

	update(this : MorphComponent)
	{
		const mesh = ( this.id ? this.el.object3DMap[ this.id ] : this.el.object3D ) as Mesh;
		if(mesh && mesh.morphTargetDictionary && mesh.morphTargetInfluences)
		{
			for(let key in this.data)
			{
				const targetIndex = Number( mesh.morphTargetDictionary[ key ] );
				if(targetIndex < mesh.morphTargetInfluences.length)
				{
					mesh.morphTargetInfluences[targetIndex] = this.data[key];
				}
			}
		}

	}

})